import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCog, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ImpersonationBanner() {
  const { user, setUser, refreshOrg } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonated_by) return null;
  const stop = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/impersonate/stop");
      setUser(data);
      await refreshOrg();
      toast.success("Back on your own account");
      nav("/settings");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not return");
      if (e.response?.status === 401) nav("/login");
    } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-400 text-black" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 mono text-xs uppercase tracking-widest font-bold">
        <UserCog className="w-4 h-4" />
        Viewing as {user.name} · {user.role?.replace("_", " ")} — everything you do here happens as this user
      </div>
      <button type="button" onClick={stop} disabled={busy} data-testid="impersonation-return-btn"
        className="inline-flex items-center gap-1 px-3 py-1 border-2 border-black mono text-xs uppercase tracking-widest font-black hover:bg-black hover:text-amber-400 transition-colors">
        <Undo2 className="w-3.5 h-3.5" /> Return to my account
      </button>
    </div>
  );
}
